import { Link } from "react-router-dom";
import { Button } from "@telluscompany/design-system";
import { Gps404 } from "@/assets/images";
import { useLocalization } from "@i18n";

const NotFoundPage = () => {
  const { translate } = useLocalization();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4">
      <div className="max-w-2xl w-full flex flex-col items-center">
        <div className="mb-8">
          <img
            src={Gps404}
            alt={translate("common.notFoundPage.title")}
            className="w-full max-w-md h-auto"
          />
        </div>

        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4 text-center">
          {translate("common.notFoundPage.title")}
        </h1>

        <p className="text-lg text-gray-600 mb-8 text-center max-w-md">
          {translate("common.notFoundPage.description")}
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <Link to="/">
            <Button size="large">
              {translate("common.notFoundPage.backToHome")}
            </Button>
          </Link>
          <Button
            variant="secondary"
            size="large"
            onClick={() => window.history.back()}
          >
            {translate("common.notFoundPage.goBack")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
